import { TableRow } from "@material-ui/core";
import React from "react";
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;

        return (
            <div>
                <h3><center><u>Feild Performance Analysis Report</u></center></h3>
                <div className="row pl-2 pb-2 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                </div>
                <div className="row pl-2 pb-2 pt-2">
                    <div className="col"><b>From: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To: </b> {searchData.toDate}</div>
                    <div className="col"></div>
                </div>
                <div>
                    <TableContainer component={Paper}>
                        <Table >
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Estate Name</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Division Name</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Field No</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>Field Name</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>AEM Officer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row" align="center"> {row.estateName}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {row.divisionName}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {row.fieldNo}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {row.fieldName}</TableCell>
                                        <TableCell component="th" scope="row" align="center"> {row.fieldCreator}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        );
    }
}